import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "d-block d-md-none" };
const _hoisted_2 = { class: "breadcrumb" };
const _hoisted_3 = {
    key: 0,
    class: "breadcrumb-item breadcrumb-item--home"
};
const _hoisted_4 = /*#__PURE__*/ _createTextVNode(" ... ");
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "d-md-block d-lg-none d-none" };
const _hoisted_8 = { class: "breadcrumb" };
const _hoisted_9 = {
    key: 0,
    class: "breadcrumb-item breadcrumb-item--home"
};
const _hoisted_10 = /*#__PURE__*/ _createTextVNode(" ... ");
const _hoisted_11 = { key: 1 };
const _hoisted_12 = { key: 1 };
const _hoisted_13 = { class: "d-none d-lg-block" };
const _hoisted_14 = { class: "breadcrumb" };
const _hoisted_15 = {
    key: 0,
    class: "breadcrumb-item breadcrumb-item--home"
};
const _hoisted_16 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("ol", _hoisted_2, [
                (_ctx.showHome)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                        _createVNode(_component_router_link, { to: "/" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_g_icon, {
                                    width: "16",
                                    height: "16",
                                    src: "/assets/icons/house-fill.svg",
                                    style: { "margin-bottom": "4px" }
                                })
                            ]),
                            _: 1
                        })
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.$host.store.getter('navigation/getBreadcrumb').length > 1)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.$host.store.getter('navigation/getBreadcrumb').slice(-2).slice(0, 1), (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                            class: _normalizeClass(['breadcrumb-item', item.active ? 'active' : '', item.disabled ? 'disabled' : ''])
                        }, [
                            (item.address)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: item.address
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_4
                                    ]),
                                    _: 2
                                }, 1032, ["to"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_5, " ... "))
                        ], 2));
                    }), 256))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$host.store.getter('navigation/getBreadcrumb').slice(-1), (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                        class: _normalizeClass(['breadcrumb-item', item.active ? 'active' : '', item.disabled ? 'disabled' : ''])
                    }, [
                        (item.address)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: item.address
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$utils.leftWithEllipsis(item.caption, 25)), 1)
                                ]),
                                _: 2
                            }, 1032, ["to"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$utils.leftWithEllipsis(item.caption, 25)), 1))
                    ], 2));
                }), 256))
            ])
        ]),
        _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ol", _hoisted_8, [
                (_ctx.showHome)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                        _createVNode(_component_router_link, { to: "/" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_g_icon, {
                                    width: "16",
                                    height: "16",
                                    src: "/assets/icons/house-fill.svg",
                                    style: { "margin-bottom": "4px" }
                                })
                            ]),
                            _: 1
                        })
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.$host.store.getter('navigation/getBreadcrumb').length > 2)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.$host.store.getter('navigation/getBreadcrumb').slice(-3).slice(0, 1), (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                            class: _normalizeClass(['breadcrumb-item', item.active ? 'active' : '', item.disabled ? 'disabled' : ''])
                        }, [
                            (item.address)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: item.address
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_10
                                    ]),
                                    _: 2
                                }, 1032, ["to"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_11, " ... "))
                        ], 2));
                    }), 256))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$host.store.getter('navigation/getBreadcrumb').slice(-2), (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                        class: _normalizeClass(['breadcrumb-item', item.active ? 'active' : '', item.disabled ? 'disabled' : ''])
                    }, [
                        (item.address)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: item.address
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$utils.leftWithEllipsis(item.caption, 25)), 1)
                                ]),
                                _: 2
                            }, 1032, ["to"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$utils.leftWithEllipsis(item.caption, 25)), 1))
                    ], 2));
                }), 256))
            ])
        ]),
        _createElementVNode("div", _hoisted_13, [
            _createElementVNode("ol", _hoisted_14, [
                (_ctx.showHome)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                        _createVNode(_component_router_link, { to: "/" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_g_icon, {
                                    width: "16",
                                    height: "16",
                                    src: "/assets/icons/house-fill.svg",
                                    style: { "margin-bottom": "4px" }
                                })
                            ]),
                            _: 1
                        })
                    ]))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$host.store.getter('navigation/getBreadcrumb'), (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                        class: _normalizeClass(['breadcrumb-item', item.active ? 'active' : '', item.disabled ? 'disabled' : ''])
                    }, [
                        (item.address)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: item.address
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$utils.leftWithEllipsis(item.caption, 25)), 1)
                                ]),
                                _: 2
                            }, 1032, ["to"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$utils.leftWithEllipsis(item.caption, 25)), 1))
                    ], 2));
                }), 256))
            ])
        ])
    ], 64));
}
